// src/services/userAnimeService.ts
import api from '../api/axios';

export const getUserWatchingAnime = async () => {
    try {
        const response = await api.get('/user/watching-now');
        return response.data;
    } catch (error) {
        console.error('Error fetching watching anime:', error);
        return [];
    }
};

export const getAllUserWatchingAnime = async () => {
    try {
        const response = await api.get('/user/list?status=WATCHING'); // ← ИСПРАВЛЕНО!
        return response.data;
    } catch (error) {
        console.error('Error fetching all watching anime:', error);
        return [];
    }
};